<script lang="ts">
    import FieldHeading from './field-heading.svelte'

    export let label: string
    export let data: Record<string, any>
    export let value: string | null = null
    export let required = false
    export let readOnly = false

    let canvasEl: HTMLCanvasElement
    let drawing = false

    // O canvas ocupa 100% da largura do bloco (até 360px), mas o buffer de desenho continua
    // sempre 360x140 — sem essa escala, o traço saía deslocado quando o bloco é mais estreito
    // (ex: largura 1/3), já que o cursor é medido em px de tela, não do buffer.
    function getScale() {
        const rect = canvasEl.getBoundingClientRect()
        return canvasEl.width / rect.width
    }

    function pointerDown(event: PointerEvent) {
        if (readOnly) return
        drawing = true
        const ctx = canvasEl.getContext('2d')
        if (!ctx) return
        ctx.strokeStyle = '#212529'
        ctx.lineCap = 'round'
        const rect = canvasEl.getBoundingClientRect()
        const scale = getScale()
        ctx.beginPath()
        ctx.moveTo((event.clientX - rect.left) * scale, (event.clientY - rect.top) * scale)
    }

    function pointerMove(event: PointerEvent) {
        if (readOnly || !drawing) return
        const ctx = canvasEl.getContext('2d')
        if (!ctx) return
        const rect = canvasEl.getBoundingClientRect()
        const scale = getScale()
        ctx.lineWidth = 2 * scale
        ctx.lineTo((event.clientX - rect.left) * scale, (event.clientY - rect.top) * scale)
        ctx.stroke()
    }

    function pointerUp() {
        if (readOnly || !drawing) return
        drawing = false
        value = canvasEl.toDataURL()
    }

    function clear() {
        if (readOnly) return
        value = null
    }
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    {#if value}
        <img src={value} alt="Assinatura" class="sign-image" />
        {#if !readOnly}
            <button type="button" class="sign-clear" on:click={clear}>Limpar assinatura</button>
        {/if}
    {:else}
        <canvas
            bind:this={canvasEl}
            width="360"
            height="140"
            class="sign-canvas"
            class:readonly={readOnly}
            on:pointerdown={pointerDown}
            on:pointermove={pointerMove}
            on:pointerup={pointerUp}
            on:pointerleave={pointerUp}
        />
    {/if}
</div>

<style>
    .sign-canvas {
        display: block;
        width: 100%;
        max-width: 360px;
        height: auto;
        aspect-ratio: 360 / 140;
        border: 1px dashed #ced4da;
        border-radius: 8px;
        background: #fbfbfc;
        touch-action: none;
        cursor: crosshair;
    }
    .sign-canvas.readonly {
        cursor: not-allowed;
        opacity: 0.7;
    }
    .sign-image {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 140px;
        border: 1px solid #ecedf0;
        border-radius: 8px;
        background: #fbfbfc;
    }
    .sign-clear {
        margin-top: 8px;
        border: none;
        background: transparent;
        color: #868e96;
        font-size: 0.8rem;
        padding: 4px 0;
        cursor: pointer;
    }
    .sign-clear:hover {
        color: var(--bs-primary, #328866);
    }
</style>
